import type { UnitInfoMobileScreenInterface } from 'store/units/types';
import { UnitTypes } from 'unitData/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { MobileScreenUnitInfoDataInterface } from './unitInfoData';

export class MobileScreenConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoMobileScreenInterface {
    const unitInfoData =
      (params?.data as MobileScreenUnitInfoDataInterface | undefined) ?? {};
    const type = params?.unitType ?? UnitTypes.MOBILE_TRACKED_SCREEN;
    if (type === UnitTypes.MOBILE_TRACKED_SCREEN) {
      const model = 'QA335';
      const modelData = unitInfoData[model];
      const modelDataUF373 = unitInfoData['UF373'];

      return {
        ...BaseUnitConfig.getBaseDefaults(),
        modelName: model,
        numberOfPorts: 4,
        configuration: modelData.configurations.configurationOptions[0],
        moisture: 0,
        newMoisture: false,
        GENERIC_SCREEN1: {
          decks: {
            0: {
              separationSize: modelData.configurations.defaultGridDeck1Sep,
            },
            1: {
              separationSize: modelData.configurations.defaultGridDeck2Sep,
            },
          },
        },
        GENERIC_SCREEN2: {
          decks: {
            0: {
              separationSize: modelData.configurations.defaultNFsepSizeDeck1,
            },
            1: {
              separationSize: modelData.configurations.defaultNFsepSizeDeck2,
            },
          },
        },
        CONVENTIONAL_SCREEN1: {
          model:
            modelDataUF373.configurations.CONVENTIONAL_SCREEN1.model
              .displayName,
          simModel:
            modelDataUF373.configurations.CONVENTIONAL_SCREEN1.model
              .simulationModel,
          deckOneRelieving: false,
          inclination: modelDataUF373.configurations.defaultInclination,
          materialType: {
            name: modelData.configurations.defaultRockMaterialName,
            value: modelData.configurations.defaultRockMaterialValue,
          },
          decks: {
            0: {
              separationSize: modelData.configurations.defaultSepSizeDeck1,
              screeningMediaId: {
                name: modelData.configurations.defaultMediaDeck1Name,
                value: modelData.configurations.defaultMediaDeck1Value,
              },
              overUnderSize: {
                name: modelDataUF373.configurations
                  .defaultOverUnderSizeDeck1Name,
                value:
                  modelDataUF373.configurations.defaultOverUnderSizeDeck1Value,
              },
            },
            1: {
              separationSize: modelData.configurations.defaultSepSizeDeck2,
              screeningMediaId: {
                name: modelData.configurations.defaultMediaDeck2Name,
                value: modelData.configurations.defaultMediaDeck2Value,
              },
              overUnderSize: {
                name: modelDataUF373.configurations
                  .defaultOverUnderSizeDeck2Name,
                value:
                  modelDataUF373.configurations.defaultOverUnderSizeDeck2Value,
              },
            },
            2: {
              separationSize:
                unitInfoData['QA451'].configurations.defaultSepSizeDeck3,
              screeningMediaId: {
                name: unitInfoData['QA451'].configurations
                  .defaultMediaDeck3Name,
                value:
                  unitInfoData['QA451'].configurations.defaultMediaDeck3Value,
              },
              overUnderSize: {
                name: unitInfoData['QA451'].configurations
                  .defaultOverUnderSizeDeck3Name,
                value:
                  unitInfoData['QA451'].configurations
                    .defaultOverUnderSizeDeck3Value,
              },
            },
          },
        },
        SPLIT1: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        SPLIT2: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        SPLIT3: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        display: {
          ...BaseUnitConfig.getDefaultDisplay(),
          displayLoad: true,
          displayConfig: false,
          displayScreenInclination: false,
          displayScreenSeparation: false,
          displayGrizzlySeparation: false,
          displayScreeningElement: false,
          displayFeederModel: false,
          displayScreenModel: false,
          displayNFScreenModel: false,
          displayScreenSplits: false,
        },
        parallelUnits: 1,
      };
    } else {
      const model = 'UF320_Classic';
      const modelData = unitInfoData[model];
      const modelDataUF373 = unitInfoData['UF373'];

      return {
        ...BaseUnitConfig.getBaseDefaults(),
        modelName: model,
        numberOfPorts: 6,
        configuration: modelData.configurations.configurationOptions[0],
        newMoisture: false,
        GENERIC_SCREEN1: {
          decks: {
            0: {
              separationSize: modelData.configurations.defaultSepSizeGrizzly,
            },
            1: {
              separationSize: 0,
            },
          },
        },
        GENERIC_SCREEN2: {
          decks: {
            0: {
              separationSize: modelData.configurations.defaultNFsepSizeDeck1,
            },
            1: {
              separationSize: modelData.configurations.defaultNFsepSizeDeck2,
            },
          },
        },
        CONVENTIONAL_SCREEN1: {
          model:
            modelDataUF373.configurations.CONVENTIONAL_SCREEN1.model
              .displayName,
          simModel:
            modelDataUF373.configurations.CONVENTIONAL_SCREEN1.model
              .simulationModel,
          deckOneRelieving: false,
          inclination: modelDataUF373.configurations.defaultInclination,
          materialType: {
            name: modelData.configurations.defaultRockMaterialName,
            value: modelData.configurations.defaultRockMaterialValue,
          },
          decks: {
            0: {
              separationSize: modelData.configurations.defaultSepSizeDeck1,
              screeningMediaId: {
                name: modelData.configurations.defaultMediaDeck1Name,
                value: modelData.configurations.defaultMediaDeck1Value,
              },
              overUnderSize: {
                name: modelDataUF373.configurations
                  .defaultOverUnderSizeDeck1Name,
                value:
                  modelDataUF373.configurations.defaultOverUnderSizeDeck1Value,
              },
            },
            1: {
              separationSize: modelData.configurations.defaultSepSizeDeck2,
              screeningMediaId: {
                name: modelData.configurations.defaultMediaDeck2Name,
                value: modelData.configurations.defaultMediaDeck2Value,
              },
              overUnderSize: {
                name: modelDataUF373.configurations
                  .defaultOverUnderSizeDeck2Name,
                value:
                  modelDataUF373.configurations.defaultOverUnderSizeDeck2Value,
              },
            },
            2: {
              separationSize: modelData.configurations.defaultSepSizeDeck3,
              screeningMediaId: {
                name: modelData.configurations.defaultMediaDeck3Name,
                value: modelData.configurations.defaultMediaDeck3Value,
              },
              overUnderSize: {
                name: modelDataUF373.configurations
                  .defaultOverUnderSizeDeck3Name,
                value:
                  modelDataUF373.configurations.defaultOverUnderSizeDeck3Value,
              },
            },
          },
        },
        SPLIT1: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        SPLIT2: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        SPLIT3: {
          amountRight: modelDataUF373.configurations.SPLIT1.defaultAmountRight,
        },
        display: {
          ...BaseUnitConfig.getDefaultDisplay(),
          displayLoad: true,
          displayConfig: false,
          displayScreenInclination: false,
          displayScreenSeparation: false,
          displayGrizzlySeparation: false,
          displayScreeningElement: false,
          displayFeederModel: false,
          displayScreenModel: false,
          displayNFScreenModel: false,
          displayScreenSplits: false,
        },
        parallelUnits: 1,
      };
    }
  }

  static getNumberOfPorts(model?: string, config?: number): number {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getNbrOfPorts(model!, config!);
  }
}

export const mobileScreenConfig = new MobileScreenConfig();

export const getNbrOfPorts = (model: string, configKey: number) => {
  const isKey = (...keys: number[]) => keys.includes(configKey);

  const isQA = model.includes('QA');
  const isQE = model.includes('QE');
  if (model === 'UF373' || model === 'UF473' || model === 'UF320_Direct') {
    return 4;
  }

  if (isQA) {
    if (model.includes('QA451') || model.includes('QA452')) {
      return configKey === 2 ? 4 : 5;
    } else {
      return configKey === 2 ? 3 : 4;
    }
  }

  if (isQE) {
    if (model === 'QE141') {
      return 2;
    }
    return configKey === 0 ? 3 : 2;
  }

  if (isKey(0)) {
    return 6;
  } else if (isKey(7)) {
    return 3;
  } else if (isKey(1, 2, 4)) {
    return 5;
  }
  return 4;
};
